/** The GraphQL query field details for a web image. */
export let imageInfoGraphQlDetails = 'url width height';